<app-loader *ngIf="isDisabled"></app-loader>
<div class="card">
    <div class="card-header">
        Reduction Of Manpower
    </div>
    <div class="card-body">
        <div class="row m-1">
            <div class="col-md-2 px-1">
                <label class="Label">Work Order Date</label>
                <div class="input-group" style="height: auto;">
                    <input class="form-control" name="WorkOrderDate" placeholder="DD/MMM/YYYY" ngbDatepicker
                        #d1="ngbDatepicker" [minDate]="{ year:1930, month: 12, day: 31 }" [(ngModel)]="WorkOrderDate"
                        [maxDate]="{ year: 2124, month: 12, day: 31 }" required
                        style="height: auto; font-size: small; padding: 0.2rem 0.4rem;"
                        [disabled]="objdata.Auto === 'A'" />
                    <button class="btn btn-outline-secondary bi bi-calendar3" (click)="d1.toggle()" type="button"
                        style="height: auto; padding: 0.25rem 0.4rem; font-size: small;"></button>
                </div>
            </div>
            <div class="col-md-2 px-1">
                <label class="Label">Work Order No.</label>
                <input name="workorderno" [(ngModel)]="WorkOrderNumber" type="text" class="form-control"
                    [disabled]="objdata.Auto === 'A'" />
            </div>
            <div class="col-md-2 px-1" *ngIf="objdata.editMode">
                <label class="Label">Entry No.</label>
                <input name="entryNo" type="text" [(ngModel)]="EntryNo" class="form-control" disabled />
            </div>
        </div>
        <div class="row m-1">
            <div class="col-md-5 px-1">
                <label class="Label">Branch <span class="text-danger">*</span></label>
                <ng-select name="branch" [items]="BranchMaster" bindLabel="BranchName" bindValue="BranchMasterID"
                    [(ngModel)]="BranchId" (change)=" onSelectChange('Branch'); ComboLoad('Client')"
                    [disabled]="objdata.editMode || objdata.siteMode">
                    <ng-option *ngFor="let segment of BranchMaster" [value]="segment.BranchMasterID">
                        {{ segment.BranchName }}
                    </ng-option>
                </ng-select>
            </div>
        </div>
        <div class="row m-1">
            <div class="col-md-8 px-1">
                <label class="Label">Client <span class="text-danger">*</span></label>
                <ng-select name="client" [items]="ClientLoad" bindLabel="ClientGroupName"
                    bindValue="ClientGroupMasterID" [(ngModel)]="ClientId"
                    (change)="onSelectChange('Client'); ComboLoad('Site')"
                    [disabled]="objdata.editMode || objdata.siteMode">
                    <ng-option *ngFor="let segment of ClientLoad" [value]="segment.ClientGroupMasterID">
                        {{ segment.ClientGroupName }}
                    </ng-option>
                </ng-select>
            </div>
        </div>
        <div class="row m-1">
            <div class="col-md-8 px-1">
                <label class="Label">Site <span class="text-danger">*</span></label>
                <ng-select name="site" [items]="SiteLoad" bindLabel="SiteName" bindValue="SiteMasterID"
                    [(ngModel)]="SiteId" (change)="onSelectChange('Site'); ComboLoad('Designation')"
                    [disabled]="objdata.editMode || objdata.siteMode">
                    <ng-option *ngFor="let segment of SiteLoad" [value]="segment.SiteMasterID">
                        {{ segment.SiteName }}
                    </ng-option>
                </ng-select>
            </div>
        </div>
        <div class="row m-1">
            <div class="col-md-4 px-1">
                <label class="Label">Attachment</label>
                <div class="file-input-container">
                    <input class="form-control form-control-sm" id="formFileSm" type="file" *ngIf="!displayedFileName"
                        (change)="onFileSelected($event)" [disabled]="SiteId === 0 || SiteId === null || objdata.Auto === 'A'" accept=".pdf" />
                    <span *ngIf="displayedFileName" class="file-name">{{ displayedFileName }}</span>
                    <span *ngIf="displayedFileName "> <button class="btn btn-sm" name="view" style="color: blue;"
                            (click)="viewFile()"><i class="bi bi-eye"></i></button></span>
                    <button class="btn btn-sm" *ngIf="displayedFileName" name="trash" (click)="removeFile()"
                        [disabled]="objdata.Auto === 'A'">
                        <i class="bi bi-trash"></i>
                    </button>
                </div>
            </div>
            <div class="col-md-3 px-1">
                <label class="Label">Allocation Type</label>
                <input name="addition" [(ngModel)]="AllocationType" type="text" class="form-control" disabled />
            </div>
            <div class="col-md-4 px-1"><br>
                <button class="btn btn-sm btn-primary" name="selectworkorder" (click)="openDetailWorkOrder()"
                    [disabled]="objdata.Auto === 'A'"><i class="bi bi-funnel-fill"></i>Select Workorder
                </button>
            </div>
        </div>
        <div class="row m-1">
        </div>
        <div class="card border-radius-0 mt-1 p-0">
            <div class="card-body p-1" style="overflow: auto;">
                <table datatable [dtOptions]="this.dtoptions" [dtTrigger]="dtTrigger"
                    class="customeDatatable table table-bordered">
                    <thead>
                        <tr>
                            <th scope="col">#</th>
                            <th style="display: none;"> Ref ESS_ShiftWiseManpowerDetailsId </th>
                            <th style="display: none;"> ESS_ShiftWiseManpowerDetailsId</th>
                            <th style="display: none;"> ESS_ShiftWiseManpowerMasterId</th>
                            <th scope="col">Entry No</th>
                            <th scope="col">WO No.</th>
                            <th scope="col">WO Dt. </th>
                            <th scope="col" style="display: none;">Designation ID</th>
                            <th scope="col">Designation</th>
                            <th scope="col" style="display: none;">Duty ID</th>
                            <th scope="col">Duty </th>
                            <th scope="col" style="display: none;">Shift ID</th>
                            <th scope="col">Shift</th>
                            <th scope="col" style="display: none;">Allotment Type </th>
                            <th scope="col">Balance</th>
                            <th scope="col">Reduction Count</th>
                            <th scope="col">Reduction Date</th>
                            <th scope="col">Remarks</th>
                            <th scope="col">Delete</th>
                        </tr>
                    </thead>
                    <tbody>
                        <tr *ngFor="let shift of RedManpowerTable; let i = index">
                            <th scope="row" [ngClass]="{'highlight-row': shift.IsMonthLocked === 1}">{{ i + 1 }}</th>
                            <td style="display: none;">{{shift.RefESS_ShiftWiseManpowerDetailsId}}</td>
                            <td style="display: none;"> {{shift.ESS_ShiftWiseManpowerDetailsId}}</td>
                            <td style="display: none;"> {{shift.ESS_ShiftWiseManpowerMasterId}}</td>
                            <td [ngClass]="{'highlight-row': shift.IsMonthLocked === 1}">{{shift.RefAdditionEntryNo}}</td>
                            <td [ngClass]="{'highlight-row': shift.IsMonthLocked === 1}">{{ shift.WONo }}</td>
                            <td [ngClass]="{'highlight-row': shift.IsMonthLocked === 1}">{{ shift.WODate }}</td>
                            <td style="display: none;">{{ shift.DesignationId }}</td>
                            <td [ngClass]="{'highlight-row': shift.IsMonthLocked === 1}">{{ shift.DesignationName }}
                            </td>
                            <td style="display: none;">{{ shift.DutyId }}</td>
                            <td [ngClass]="{'highlight-row': shift.IsMonthLocked === 1}">{{ shift.DutyName }}</td>
                            <td style="display: none;">{{ shift.ShiftId }}</td>
                            <td [ngClass]="{'highlight-row': shift.IsMonthLocked === 1}">{{ shift.ShiftTitle }}</td>
                            <td style="display: none;">{{ shift.AllocationType }}</td>
                            <td class="right-align" [ngClass]="{'highlight-row': shift.IsMonthLocked === 1}">
                                <span class="no-of-person">{{ shift.Balance }}</span>
                            </td>
                            <td class="right-align" [ngClass]="{'highlight-row': shift.IsMonthLocked === 1}">
                                <span class="no-of-person">{{ shift.NoOfPerson}}
                                </span>
                            </td>
                            <td [ngClass]="{'highlight-row': shift.IsMonthLocked === 1}">{{shift.FromDate}}</td>
                            <td [ngClass]="{'highlight-row': shift.IsMonthLocked === 1}">{{ shift.Remarks }}</td>
                            <td [ngClass]="{'highlight-row': shift.IsMonthLocked === 1}">
                                <button class="btn btn-sm" name="delete" style="color: red;" (click)="deleteRow(i)"
                                    [disabled]="shift.IsMonthLocked === 1 || objdata.Auto === 'A'"><i
                                        class="bi bi-trash-fill"></i></button>
                            </td>
                        </tr>
                    </tbody>
                </table>
            </div>
        </div>
    </div>

    <div class="card-footer">
        <div class="row">
            <div class="col">

                <div class="row">
                </div>
                <div class="row">
                </div>
            </div>
            <div class="col-auto">
                <button *ngIf="this.common.PageRight.IsEdit || this.common.PageRight.IsAdd"
                    class="btn btn-sm btn-primary" name="save" (click)="save()" [disabled]="objdata.Auto === 'A'">
                    <i class="bi bi-save" *ngIf="!isDisabled"></i>
                    <span class="spinner-border spinner-border-sm" role="status" aria-hidden="true"
                        *ngIf="isDisabled"></span>
                    {{!isDisabled?'Save':'Loading...'}}
                </button>
                &nbsp;<button class="btn btn-sm btn-primary" name="refresh" (click)="refresh()">
                    <i class="bi bi-arrow-left" *ngIf="!isDisabled"></i>
                    <span class="spinner-border spinner-border-sm" role="status" aria-hidden="true"
                        *ngIf="isDisabled"></span>
                    {{!isDisabled?'Back':'Loading...'}}
                </button>
            </div>
        </div>
    </div>

</div>